import {Injectable} from '@angular/core';
import {GridLayoutService} from '@irb-common/interfaces/grid-layout.service';
import {MoveSecuritiesGridDataDialogComponent} from "@irb/irb-editors/editor-security/move-securities-grid-data-dialog/move-securities-grid-data-dialog.component";

@Injectable({
    providedIn: 'root'
})
export class MoveSecuritiesGridDataDialogGridLayoutService implements GridLayoutService<MoveSecuritiesGridDataDialogComponent> {
    constructor() {
    }

    getFrameworkComponents() {
        return {};
    }

    getColumnDefs() {
        return [{
            headerName: 'Symbol',
            field: 'securitySymbol',
            maxWidth: 130,
            width: 130,
            cellRenderer: 'cellRendererFormatter',
            sort: 'asc'
        },
            {
                headerName: 'Security Description',
                field: 'securityDescription',
                maxWidth: 250,
                width: 250,
                cellRenderer: 'cellRendererFormatter'
            },
            {
                headerName: 'Security Type',
                field: 'securityType',
                maxWidth: 220,
                width: 200,
                cellRenderer: 'cellRendererFormatter',
                valueGetter:(params: any)=>{
                    const val = this.formatSecurityTypeGlobal(params?.data?.securityType);
                    return val;
                }
            }];
    }

    formatSecurityTypeGlobal(item: string)
    {
        switch(item)
        {
            case "EQUITY":
                return "Equity";
            case "EQ":
                return "Equity";
            case "MUTUAL_FUND":
                return "Mutual Fund";
            case "MF":
                return "Mutual Fund";
            case "CASH":
                return "Cash";
            case "GROUP":
                return "Group";
            case "BOND":
                return "Bond";
            case "OTHER":
                return "Other";
            case "EXTERNAL":
                return "External";
            case "CustCat":
                return "Category";
            case "OPTION":
                return "Option";
            default:
                return item;
        }
    }
}
